<template>
  <div>
    <b-navbar align="center" toggleable="lg" sticky type="light" variant="light"   class="heade" >
      <b-navbar-brand class="logo">
      <div class="logflex">
        <b-img
          :src="logo"
          class="loimg"
        ></b-img>
        <div class="logtit1">易梯配</div>
        <div class="logtit2">供应商平台</div>
      </div>
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse" ></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="aaa">
        <b-nav-item @click="over(1,0,0)" :class="['header_text', index==1?'header_glide':'']">首页</b-nav-item>
        <b-nav-item @click="over(2,540,540)" :class="['header_text', index==2?'header_glide':'']">平台介绍</b-nav-item>
        <b-nav-item @click="over(3,919,1216)" :class="['header_text', index==3?'header_glide':'']">平台优势</b-nav-item>
        <b-nav-item @click="over(4,1461,1958)" :class="['header_text', index==4?'header_glide':'']">合作流程</b-nav-item>
        <b-nav-item @click="over(5,1705,2142)" :class="['header_text', index==5?'header_glide':'']">联系我们</b-nav-item>
        <b-nav-item class="header_text"><b-button variant="outline-primary" class="btns mobile-hezuo" @click="over(5,1705,2142)" >立即合作</b-button></b-nav-item>
      </b-navbar-nav>
    </b-collapse>
      <b-button variant="outline-primary" class="btns pc-hezuo" @click="over(5,1705,2142)" >立即合作</b-button>
    </b-navbar>
    <div>
      <!-- 轮播图 -->
      <Swipers ></Swipers>
      <!-- 平台介绍 -->
      <introduce style="background-color: #f8f9fa;padding-bottom: 1px;"></introduce>
      <!-- 为什么选择 -->
      <why></why>
      <!-- 最新询价 -->
      <inquire :tableData="tableData"></inquire>
      <!-- 合作流程 -->
      <cooperate ></cooperate>
      <!-- 联系我们 -->
      <contact @add="add" :id="id"></contact>
      <vfooter></vfooter>
    </div>
    <el-dialog
      title="完善信息"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      >
      <el-form ref="form" :model="form" label-width="104px">
        <el-form-item :label="type=='制造'?'配件名称':'主营品类/品牌'" v-if="type!='零售'">
          <el-input class="elinput" type="text" size="mini" :placeholder="type=='制造'?'请输入制造的配件名称':'请输入 1-2 个主营品类/品牌，如钢丝绳或通力电梯配件'" v-model="form.accessory_part"></el-input>
        </el-form-item>
        <el-form-item :label="type=='制造'?'供货品牌':'库存货值'">
          <el-input class="elinput" size="mini" :placeholder="type=='制造'?'请输入(曾)供货的品牌,如通力':'请输入库存货值'" v-model="form.inventory_value"></el-input>
        </el-form-item>
        <el-form-item label="年销售额">
          <el-input class="elinput2" size="mini" type="number" placeholder="请输入年销售额" v-model="form.annual_sales"></el-input>
          <span>万元</span>
        </el-form-item>
        <el-form-item label="所在地区">
          <el-cascader
              ref="cascader"
              v-model="address1"
              :options="getTreeData"
              :props="{
                value: 'name',
                label: 'name',
                children: 'sub',
              }"
              placeholder="请选择所在地区"
              size="mini"
              @change="handle"
              class="enemt"
              style="width: 17rem;"
              clearable
            ></el-cascader>
          <!-- <el-input class="elinput" size="mini" placeholder="地区" v-model="form.location"></el-input> -->
        </el-form-item>
      </el-form>
      <!-- <span slot="footer" class="dialog-footer"> -->
        <el-button size="mini" style="width:121px" type="primary" @click="edit">确 定</el-button>
      <!-- </span> -->
    </el-dialog>
    <div class="dialog1" v-show="show">
        <dialog1 @add="add" :id="id"></dialog1>
      </div>
      <div class="shang">
        <b-img class="shang2" :src="zhao"></b-img>
        <div class="kefus">{{ kefu }}</div>
      </div>
  </div>
</template>
<script>
import request from"../../utils/request"
import Swipers from"./componts/swipers.vue"
import introduce from"./componts/introduce.vue"
import inquire from"./componts/inquire.vue"
import cooperate from"./componts/cooperate.vue"
import contact from"./componts/contact.vue"
import vfooter from"./componts/vfooter.vue"
import why from"./componts/why.vue"
import dialog1 from"./componts/dialog1.vue"
export default {
  name: 'HelloWorld',
  components:{
    Swipers,
    introduce,
    inquire,
    cooperate,
    contact,
    vfooter,
    dialog1,
    why
  },
  props: {
    msg: String
  },
  data(){
    return{
      show:true,
      show2:false,
      zhao:require('../../stater/zhao_phon.png'),
      logo:require("../../stater/logos.png"),
      clientWidth:document.body.clientWidth,
      dialogVisible:false,
      dialogWidth:"35%",
      form:{
        id:'',
        accessory_part:'',
        inventory_value:'',
        annual_sales:'',
        location:'',
      },
      id:'',
      formto:{},
      type:'',
      address1:[],
      getTreeData:[],
      index:1,
      scrollTop:0,
      tableData:[],
      kefu:'',
    }
  },
  watch:{
    // clientWidth(newVal,oldVal){
    //     if(newVal<1000){
    //       this.show=false
    //     }else{
    //       this.show=true
    //     }
    // }
  },
  mounted(){
    let that = this;
    // if(that.clientWidth<1000){
    //   this.show=false
    //   this.dialogWidth = "95%"
    // }else{
    //   this.show=true
    //   this.dialogWidth = "35%"
    // }
    that.list()
    // if(!JSON.parse(localStorage.getItem('index'))){
    //   localStorage.setItem('index',that.index)
    // }else{
    //   that.index = JSON.parse(localStorage.getItem('index'))
    // }
    that.$nextTick(function () {
      window.addEventListener("scroll", that.handleScroll);
      window.onresize =() =>{
            return (()=>{
                window.clientWidth = document.body.clientWidth;
                that.clientWidth = window.clientWidth;
            })()
        }
    });
  },
  methods:{
    list(){
      request({
        url:"/gys/index/config",
        method:"get",
        params:{}
      }).then((res)=>{
        this.tableData=res.data.inquireLog
        this.kefu=res.data.kefu
        res.data.region.forEach((i)=>{
          i.sub.forEach((s)=>{
            delete s.sub
          })
        })
        this.getTreeData=res.data.region
      }).catch((err)=>{
      })
    },
    //完善
    edit(){
      request({
        url:"/gys/index/fullFillInfo",
        method:"post",
        data:this.form
      }).then((res)=>{
        this.dialogVisible=false
        this.$message.success(res.msg)
      }).catch((err)=>{
      })
    },
    //提交
    add(form){
      this.formto=form
      request({
          url:"/gys/index/cooperate",
          method:"post",
          data:this.formto
        }).then((res)=>{
          if(res.data.id){
            this.form.id=res.data.id
            this.id=res.data.id
            if(this.formto.company_type){
              this.form.id=res.data.id,
              this.type=this.formto.company_type
              this.dialogVisible=true
              // this.$emit('hasen',fos)
              this.hasen()
            }
          }
        }).catch((err)=>{
          console.log(err)
        })
    },
    handle(e){
      this.form.location=e.join(',')
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量

          if(scrollTop>=0 && scrollTop<540){
            this.index=1
          }else if(scrollTop>=540 && scrollTop<919){
            this.index=2
          }else if(scrollTop>=919 && scrollTop<1461){
            this.index=3
          }else if(scrollTop>=1461 && scrollTop<1705){
            this.index=4
          }else if(scrollTop>=1705){
            this.index=5
          }
      if (scrollTop > 500) {
        this.seeThis = false;
      } else {
        this.seeThis = true;
      }
    },
    over(val,num,vals){
      // localStorage.setItem('index',this.index)
      if(val!=5){
        window.scrollTo({
 				top: num,
				behavior: 'smooth'
 			})
      }else{
        window.scrollTo(0,50000);
      }
      
    }
  }
}
</script>
<style scoped>
.pc-hezuo {
  margin-right: 5rem;
  margin-left: 0rem!important;
}
.mobile-hezuo{
  display: none;
}
.shang{
  right: 1rem;
    bottom: 5rem;
    position: fixed;
    z-index: 1000;
}
.shang2{
  width: 100px;
}
.kefus{
  position: absolute;
  top: 7.7rem;
  margin-left: 13px;
  width: 75%;
  font-size: 12px;
  background-color: #fff;
  color: #1f82d7;
  white-space: nowrap;
}
.loimg{
  width: 42px;
}
.logflex{
  display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
}
.logtit1{
  font-size: 18px;
    border-right: 1px solid #ffffffc9;;
    color: #ffffffe0;;
    margin: 0px 2px;
    padding: 0 10px;
    height: 16px;
    line-height: 14px;
}
.logtit2{
  font-size: 13px;
    margin: 0 8px;
    color: #ffffffe0;;
}
.elinput{
  width: 18rem;
}
.elinput2{
  width: 15rem;
  margin-right:10px
}
div /deep/.el-dialog__header{  
    text-align: left;   
  }
.btns{
  border: 1px solid #fff;
  margin-left: 14rem;
  color: white;
  border-radius: 30px;
  font-size: 13px;
}
.logo{
  width:100px;
  margin-left: 5rem;
}
.heade{
  height: 75px;
  display: flex;
    justify-content: space-between;
    padding-left: 15px;
    padding-right: 15px;
    background: linear-gradient(to right,#1b73cf,#0dcaf0);
    border-bottom: 1px solid #c0c4cc;
}
.header_text{
  font-size:16px;
  /* background-color: white; */
    color: #f1f3f5;
    font-weight: 600;
    margin: 0 5px;
    height: 63px;
    line-height: 63px;
}
.header_glide{
  /* border-bottom: 2px solid #fff; */
  display: inline-block;
  position: relative;
  border-bottom: 2px solid white;
  padding-bottom: 10px;
  /* width:10px */
}
.header_glide::after{
  /* border-bottom: 2px solid #fff; */
  /* content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  height: 0;
  width: 100%;
  background: white;
  transition-property: all;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94); */
  /* width:10px */
}
.dialog1{
  position: absolute;
  top: 5rem;
    right: 3rem;
    width: 315px;
    height: 422px;
    z-index:1000;
    border-radius: 5px;
}
.header_text:hover, .header_text:focus {
    color: rgb(28 50 196);
}
.nav-link{
  color:white;
  font-family: monospace;
  font-size: 13px;
}
.nav-link:hover, .nav-link:focus {
  color:white;
}
/* .navbar-brand:hover::after, .navbar-brand:focus::after {
    content: '';
    width:50px;
    height: 2px;
    background-color:blue
} */
.aaa{
  margin-left: 8rem;
  white-space: nowrap;
  margin-bottom: 12px;
}
div /deep/ .el-dialog{
  width:30%;
}
@media screen and (max-width: 990px) {
  .dialog1{
    position: relative;
  }
  .header_text{
    background-color: #1b73cf;
  }
  .pc-hezuo {
    display: none;
  }
  .mobile-hezuo {
    display: inline-block;
  }
  .logo{
    margin-left:0
  }
}
@media screen and (max-width: 1100px) {
  div /deep/ .el-dialog{
  width:310px;
}
  .btns{
    margin-left:0rem
  }
  .heade{
    /* background: linear-gradient(to top,#1b73cf,#0dcaf0); */
}
}
@media screen and (max-width: 850px) {
  
  .logo[data-v-498142aa] {
    /* margin-left: -3rem; */
}
}
</style>